import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'
import sanitizeHtml from 'sanitize-html'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import ProcessingImage from './ProcessingImage'

const data = {
  heading: `Processing`,
  section1: `Data can be messy. As anyone who has dealt with third-party APIs, JSON blobs, and semi-structured text knows that only 20-30% of your time is spent driving insights. Most of your time is spent cleaning the data you already have.`,
  section2: `At minimum, you’ll want to make sure your data infrastructure can:`,
  section3: `<ul><li>Handle GDPR suppressions across millions of users</li>
  <li>Validate and enforces arbitrary inputs</li>
  <li>Allow you to transform and format individual events</li>
  <li>Deduplicate retried requests</li></ul>`,
  section4: `Here’s how we do it.`,
}

const Processing: FC<PropsWithChildren<unknown>> = () => {
  const { heading, section1, section2, section3, section4 } = data
  return (
    <Wrapper>
      <SectionBase variant="2Col" copyVariant="wide">
        <Section.Copy>
          <CopyTextBase>
            <CopyText.Heading>{heading}</CopyText.Heading>
            <CopyText.Description tag="div">
              <CopyTextDescriptionSection>{section1}</CopyTextDescriptionSection>
              <CopyTextDescriptionSection>{section2}</CopyTextDescriptionSection>
              <CopyTextDescriptionSection
                dangerouslySetInnerHTML={{
                  __html: sanitizeHtml(section3, { allowedTags: [`ul`, `li`, `br`] }),
                }}
              />
              <CopyTextDescriptionSection>{section4}</CopyTextDescriptionSection>
            </CopyText.Description>
          </CopyTextBase>
        </Section.Copy>
        <Section.Contents>
          <ProcessingImage />
        </Section.Contents>
      </SectionBase>
    </Wrapper>
  )
}

const CopyTextDescriptionSection = styled.div`
  margin-bottom: 32px;
`

const Wrapper = styled.section`
  display: grid;
`

export default Processing
